/**
 * Defines the application environment development configuration.
 * Contains environment-specific settings used by the application,
 * including the production mode and backend API base URL.
 */
export const environment = {
  production: false,
  apiBaseUrl: 'https://uat.zbapps.zenbasket.in',
};
